import React, { Component } from 'react';
import { Create, SimpleForm, TextInput} from 'react-admin';


export default class GroupsOptionsCreate extends Component{
    render(){
        return(
            <Create {...this.props} title="Crear un nuevo departamento para los contactos">
                <SimpleForm>
                    <TextInput source="name" label="Nombre"/>
                </SimpleForm>
            </Create>
        )
    }
}